import Script from "next/script";

import { log } from "shared-lib/helpers/logging/logger";

import { getHumixSrc } from "@/lib/helpers/brandFunctions";

export default function EzoicVideoPlayer() {
  const props = {};
  const videoContainerId = "viewport-video";
  const videoPlayerHTML = "(window.humixPlayers = window.humixPlayers || []).push({ target: document.getElementById(\"viewport-video\") })";

  return (
    <>
      <div
        id={videoContainerId}
        {...props}
        style={{ flex: 1, maxWidth: "560px" }}
      >
        <Script
          src={getHumixSrc()}
          onReady={() => {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.innerHTML = videoPlayerHTML;
            document.getElementsByTagName('head')[0].appendChild(script);
            { (log(`Video Player: document.getElementById(${videoContainerId}) >>> `, document.getElementById(videoContainerId))) }
            { (log("Video Player: window.humixPlayers >>> ", window.humixPlayers)) }
          }}
        />
      </div>
    </>
  );
}
